import React from "react";

function SkeletonBlock({ className = "" }) {
  return <div className={`student-skeleton ${className}`.trim()} />;
}

export default function Loader() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:px-8">
      <div className="student-loading-shell">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center">
          <SkeletonBlock className="mx-auto h-36 w-36 rounded-full lg:mx-0" />
          <div className="flex-1 space-y-4">
            <SkeletonBlock className="h-4 w-28 rounded-full" />
            <SkeletonBlock className="h-12 w-full max-w-md rounded-2xl" />
            <SkeletonBlock className="h-5 w-full max-w-lg rounded-full" />
            <div className="grid gap-3 sm:grid-cols-3">
              <SkeletonBlock className="h-24 rounded-3xl" />
              <SkeletonBlock className="h-24 rounded-3xl" />
              <SkeletonBlock className="h-24 rounded-3xl" />
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 grid gap-6 xl:grid-cols-2">
        {[0, 1, 2, 3].map((item) => (
          <div key={item} className="student-loading-shell p-6">
            <SkeletonBlock className="h-7 w-40 rounded-full" />
            <div className="mt-5 grid gap-4 sm:grid-cols-2">
              {[0, 1, 2, 3].map((field) => (
                <div key={field} className="rounded-3xl border border-white/70 p-4">
                  <SkeletonBlock className="h-3 w-24 rounded-full" />
                  <SkeletonBlock className="mt-3 h-7 w-full rounded-2xl" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
